export default {
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    redirectPath: {
      type: String,
      default: null,
    },
  },
  computed: {
    hoursUsedMessage() {
      if (!this.policyType) {
        return null;
      }

      return `(${this.policyType})`;
    },
    hasPendingApproval() {
      return this.pendingApproval !== '0:00';
    },
  },
  watch: {
    timeOffRequestDays(newVal) {
      this.showPagination = newVal.length > 0;
    },
  },
  methods: {
    calculatePaginationItems(page = null) {
      const totalDays = this.timeOffRequestDays.length;
      const totalPages = Math.ceil(totalDays / 7);

      if (page) {
        this.currentPage = page;
      }

      if (this.currentPage > totalPages) {
        this.currentPage = totalPages;
      }

      this.pagination.current_page = this.currentPage;
      this.pagination.total_pages = totalPages;
      this.pagination.next_page = this.currentPage + 1;
      this.pagination.prev_page = this.currentPage - 1;
      this.pagination.limit_value = 7;
      this.pagination.total_count = totalDays;
      this.pagination.first_page = this.currentPage === 1;
      this.pagination.last_page = this.currentPage >= totalPages;

      const start = (this.currentPage - 1) * this.pagination.limit_value;
      const end = start + this.pagination.limit_value;

      this.paginatedItems = this.timeOffRequestDays.slice(start, end);
      this.pagination.current_count = this.paginatedItems.length;
    },
    holidayType(timeOffRequestDay) {
      const holidayHours = this.holidayAmountUsedHours(timeOffRequestDay);

      if (holidayHours === '0:00') {
        return `Unpaid Holiday`;
      }

      return 'Paid Holiday';
    },
    holidayAmountUsedHours(timeOffRequestDay) {
      const holiday = this.holidays.find((holiday) => holiday.date === timeOffRequestDay.date);

      if (!holiday) {
        return '';
      }

      return TimeUtils.format_duration(moment.duration(holiday.amount_used, 'seconds'), false);
    },
    hideDetails(value) {
      this.showDetails = value;
    },
    formatBalanceInformation(balance) {
      if (balance === null || balance === undefined) {
        return '';
      }

      return TimeUtils.format_duration(moment.duration(balance, 'seconds'), false);
    },
    formatDate(date) {
      return moment(date).format('ddd, MMM DD, YYYY');
    },
    processHolidays(holidays) {
      return holidays.reduce((holidaysAccumulator, holiday) => {
        const existingHoliday = holidaysAccumulator.find((h) => h.date === holiday.date);

        if (existingHoliday) {
          existingHoliday.amount_used += holiday.amount_used;
        } else {
          holidaysAccumulator.push({ date: holiday.date, amount_used: holiday.amount_used });
        }

        return holidaysAccumulator;
      }, []);
    },
  },
};
